import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';

import { LayoutService } from '../../services/layout.service';
import { AnalyticsService } from '../../services/analytics.service';

interface NavLink {
  label: string;
  icon: string;
  path: string;
  exact: boolean;
  /** Shown in the mobile tab bar; the rest move into the "More" sheet. */
  tab: boolean;
}

/**
 * Primary navigation. Renders as a labelled sidebar on desktop and as a
 * bottom tab bar on compact viewports — the standard music-app pattern.
 */
@Component({
  selector: 'navbar-component',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, MatIconModule, MatMenuModule, MatTooltipModule],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavbarComponent {
  protected readonly layout = inject(LayoutService);
  private readonly analytics = inject(AnalyticsService);

  protected readonly primary: NavLink[] = [
    { label: 'Browse', icon: 'home', path: '/radios', exact: true, tab: true },
    { label: 'Now Playing', icon: 'play_circle', path: '/now-playing/manual', exact: false, tab: true },
    { label: 'Favorites', icon: 'star', path: '/favorites', exact: true, tab: true },
    { label: 'Equalizer', icon: 'graphic_eq', path: '/equalizer', exact: true, tab: true },
  ];

  protected readonly secondary: NavLink[] = [
    { label: 'About HX Player', icon: 'info', path: '/settings', exact: true, tab: false },
    { label: 'Copyrights & Privacy', icon: 'policy', path: '/copyrights-and-privacy-policy', exact: true, tab: false },
  ];

  protected onGooglePlayClick(): void {
    void this.analytics.logGooglePlayClick();
  }
}
